<script setup>
const props = defineProps({
    text: String,
    uniqId: String,
    modelValue: Boolean
});

const emit = defineEmits(["update:modelValue"]);
</script>

<template>
    <div class="wrapper">
        <div>
            <input 
                type="checkbox" 
                class="checkbox" 
                :id="props.uniqId" 
                @change="emit('update:modelValue', $event.target.checked)"
                :checked="props.checked"
            />

            <label :for="props.uniqId" class="checkbox-label" :class="$attrs.class">
                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 12L0 6L2 4L6 8L14 0L16 2" fill="#D4D4D4"/>
                </svg>
            </label>
        </div>

        <p class="checkbox-text">
            {{ props.text }}
        </p>
    </div>
</template>

<style scoped>
.wrapper {
    position: relative;

    display: flex;
    align-items: flex-start;

    gap: 10px;
}

.checkbox-label {
    width: 29px;
    height: 29px;

    border-radius: 5px;

    display: flex;
    align-items: center;
    justify-content: center;
}

.checkbox-label:hover path {
    fill: #1463C6;
}

.checkbox-label.error-checkbox {
    border: 1px solid #F5010A;
}

.checkbox:checked + .checkbox-label path {
    fill: white;
}

.checkbox:checked + .checkbox-label {
    background-color: #1463C6;
    border: 1px solid #1463C6;
}

.checkbox {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
}

.checkbox-text {
    color: #787878;
    font-size: 16px;
    font-weight: 400;
}

@media screen and (max-width: 1280px) {
    .checkbox {
        width: 0!important;
        height: 0!important;
        accent-color: unset;
    }

    .wrapper {
        padding: 0 15px;
    }
}
</style>